module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_100_250.ee2da65d.png";